<template>
  <div class="check_list">
    <v-col cols="12" class="check_list-area">
      <v-row>
        <v-col cols="2" v-if="userAuthority === 'MANAGER' && isUnderEditing">
          <CheckListAddItemButton @addItemAction="addItem" />
        </v-col>
      </v-row>
      <div v-for="(ecoItem, index) in inputEcoItems" :key="ecoItem.name">
        <CheckListItem
          :user-authority="userAuthority"
          :is-under-editing="isUnderEditing"
          :description.sync="ecoItem.name"
          :category.sync="ecoItem.earth_impact_type"
          :point.sync="ecoItem.point"
          :reason.sync="ecoItem.reason"
          :index="index"
          :is-checked.sync="isCheckedArray[index]"
          @deleteItem="deleteItem($event)"
          @checkItem="checkItem($event)"
        />
      </div>
    </v-col>
  </div>
</template>

<script>
import CheckListItem from "../Molecules/CheckListItem";
import CheckListAddItemButton from "../Atoms/CheckListAddItemButton";

export default {
  name: "CheckList",
  data: () => ({
    listItems: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
    descriptionArray: [],
    categoryArray: [],
    pointArray: [],
    reasonArray: [],
  }),
  created() {
  },
  computed: {
    inputEcoItems: {
      get() {
        return this.ecoItems;
      },
      set(value) {
        this.$emit("update:ecoItems", value);
      }
    },
    isCheckedArray() {
      let isCheckedArray = []
      for (let ecoItem of this.ecoItems) {
        if (this.checkedEcoItemIds.includes(ecoItem.id)){
          isCheckedArray.push(true)
        } else {
          isCheckedArray.push(false)
        }
      }
      return isCheckedArray
    }
  },
  methods: {
    addItem() {
      let ecoItem = {
        name: null,
        action_type: null,
        earth_impact_type: "GLOBAL_WARMING",
        point: "1",
        reason: "理由を記入してください"
      };
      this.ecoItems.unshift(ecoItem);
    },
    deleteItem(index) {
      this.$emit("deleteItem", index);
    },
    checkItem(index){
      this.$emit("checkItem", index);
    }
  },
  components: {
    CheckListItem,
    CheckListAddItemButton
  },
  props: [
    "userAuthority",
    "actionType",
    "ecoItems",
    "postEcoItems",
    "isUnderEditing",
    "checkedEcoItemIds"
  ]
};
</script>

<style scoped>
.check_list {
  height: 100%;
}
.check_list-area {
  border: 1px dashed #ffffff;
  border-radius: 16px;
  overflow: scroll;
  height: 100%;
}
</style>
